import { PrepaidShareType } from 'src/lib/types/rtoSuite'
import { z } from 'zod'

export const splitCodSlabSchema = z.object({
  minOrderValue: z.number().min(1, 'Min order value must be at least 1'),
  maxOrderValue: z.number().min(1, 'Must be greater than 0').nullable(),
  prepaidShare: z.number().min(1, 'Prepaid share must be at least 1'),
  prepaidShareType: z.enum(PrepaidShareType),
  isCODChargesExcluded: z.boolean()
})

export const splitCodConfigSchema = z.object({
  slabs: z
    .array(splitCodSlabSchema)
    .min(1, 'At least one slab is required')
    .superRefine((slabs, ctx) => {
      slabs.forEach((slab, index) => {
        if (slab.maxOrderValue && slab.maxOrderValue <= slab.minOrderValue) {
          ctx.addIssue({
            code: 'custom',
            message: 'Max value must be greater than Min value',
            path: [index, 'maxOrderValue']
          })
        }

        if (slab.prepaidShareType === PrepaidShareType.Percentage && slab.prepaidShare > 100) {
          ctx.addIssue({
            code: 'custom',
            message: 'Percentage cannot exceed 100',
            path: [index, 'prepaidShare']
          })
        }

        if (
          slab.prepaidShareType === PrepaidShareType.Flat &&
          slab.maxOrderValue &&
          slab.prepaidShare >= slab.maxOrderValue
        ) {
          ctx.addIssue({
            code: 'custom',
            message: 'Must be less than max order value',
            path: [index, 'prepaidShare']
          })
        }

        if (index > 0) {
          const prevSlab = slabs[index - 1]
          if (!prevSlab.maxOrderValue) {
            ctx.addIssue({
              code: 'custom',
              message: 'Previous slab must have a max limit',
              path: [index - 1, 'maxOrderValue']
            })
          } else if (slab.minOrderValue !== prevSlab.maxOrderValue + 1) {
            ctx.addIssue({
              code: 'custom',
              message: `Min value must be ${prevSlab.maxOrderValue + 1}`,
              path: [index, 'minOrderValue']
            })
          }
        }
      })
    })
})

export type SplitCodFormValues = z.infer<typeof splitCodConfigSchema>
